export default __webpack_public_path__ + "static/a2z-logo-f6c9aec918240638a5ab7ad0e3aad412.png";